import Button from '@jetbrains/ring-ui/components/button/button'
import * as React from 'react'

import type {AgentId, AgentPoolId} from '../../../../../types'

type DefaultProps = {
  isCloud: boolean
}
export type Props = DefaultProps & {
  agentId: AgentId
  poolId?: AgentPoolId | null
  className?: string
  isAuthorizeable: boolean
  showAuthorizeAgentDialog: (agentId: AgentId, poolId: AgentPoolId, isCloud: boolean) => unknown
}

class AuthorizeAgent extends React.PureComponent<Props> {
  static defaultProps: DefaultProps = {
    isCloud: false,
  }

  handleClick: () => void = () => {
    const {agentId, poolId, isCloud, showAuthorizeAgentDialog} = this.props
    if (poolId != null) {
      showAuthorizeAgentDialog(agentId, poolId, isCloud)
    }
  }

  render(): React.ReactNode {
    const {isAuthorizeable, className} = this.props

    if (!isAuthorizeable) {
      return null
    }

    return (
      <div className={className}>
        <Button onClick={this.handleClick}>{'Authorize'}</Button>
      </div>
    )
  }
}

export default AuthorizeAgent
